import type { ReactElement } from 'react';
import React from 'react';

import { Box, ThemeConstellation } from '@zillow/constellation';

const RTBCardLoading: React.FC = (): ReactElement => (
    <Box
        className="rtbCardLoading"
        sx={{
            '@media $xl': {
                height: '480px',
            },
            [`@media (min-width: ${ThemeConstellation.constellation.breakpoints.md}px) and (max-width: 596px)`]:
                {
                    height: '480px',
                },
            [`@media (min-width: 597px) and (max-width: ${ThemeConstellation.constellation.breakpoints.xl}px)`]:
                {
                    height: '300px',
                },
            [`@media $sm_lte`]: {
                height: '480px',
            },
        }}
    >
        <Box
            sx={{
                'animationDuration': '1.5s',
                'animationFillMode': 'forwards',
                'animationIterationCount': 'infinite',
                'animationTimingFunction': 'linear',
                'backgroundImage': '$PropertyCard.loading.backgroundImage',
                'backgroundColor': '$PropertyCard.loading.backgroundColor',
                'backgroundRepeat': 'no-repeat',
                'backgroundSize': '100%',
                'height': '100%',
                'width': '100%',
                'position': 'relative',
                '@keyframes shimmer': {
                    '0%': {
                        backgroundPosition: '-600px 0',
                    },
                    '100%': {
                        backgroundPosition: '600px 0',
                    },
                },
                'animationName': 'shimmer',
            }}
        ></Box>
    </Box>
);

export default RTBCardLoading;
